export const SHARED_OFFER_DETAILS_KEY = 'shared_offer_details'

export const SELECT_OFFER_SENDER_MODE_TOOLTIP = 'Switch to the traveler role to select offers.'
